import React, { useState, useRef, useEffect } from "react";
import styled from "@emotion/styled";
import { Typography, Colors } from "@factorearth/component-library";

interface MultiToggleButtonProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
	colorPalette: Colors;
	optionsObj: Record<string, Category>;
	selected: string;
	setSelected: (value: string) => void;
}

interface Category {
	icon?: React.JSX.Element;
	title?: string;
	dataTestId?: string;
}

const MultiToggleButtonDiv = styled.div<{ colorPalette: Colors }>`
	display: flex;
	width: fit-content;
	border-radius: 4px;
	border: ${({ colorPalette }) => colorPalette.text.tertiary} 1px solid;
`;

const CategoryDiv = styled.div<{ colorPalette: Colors; selected: boolean }>`
	height: 33px;
	border-left: ${({ colorPalette }) => colorPalette.text.tertiary} 1px solid;
	background: ${({ selected, colorPalette }) => (selected ? colorPalette.text.tertiary : "none")};
	color: ${({ selected, colorPalette }) => (selected ? colorPalette.background.primary : colorPalette.text.tertiary)};
	position: relative;
	cursor: pointer;

	&:first-child {
		border-left: none;
	}
`;

const CategoryTitle = styled.div`
	display: inline-flex;
	gap: 8px;
	padding: 8px;
`;

export const MultiToggleButton = (props: MultiToggleButtonProps) => {
	const { colorPalette, optionsObj, selected, setSelected, ...inputProps } = props;
	const [categories, setCategories] = useState<string[]>();
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		setCategories(Object.keys(optionsObj));
	}, [optionsObj]);

	const toggleSelected = (location: string) => {
		setSelected(location);
	};

	return (
		<MultiToggleButtonDiv colorPalette={colorPalette} ref={ref}>
			{categories?.map((cat) => {
				return (
					<CategoryDiv
						key={cat}
						data-test={optionsObj[cat]?.dataTestId}
						colorPalette={colorPalette}
						selected={selected === cat}
						onClick={() => {
							toggleSelected(cat);
						}}>
						<CategoryTitle>
							{optionsObj[cat]?.icon}
							<Typography
								textColor={selected === cat ? colorPalette.background.primary : colorPalette.text.tertiary}
								content={optionsObj[cat]?.title || cat}
								variant="Small"
							/>
						</CategoryTitle>
					</CategoryDiv>
				);
			})}
		</MultiToggleButtonDiv>
	);
};
